import React from 'react';
import { withRouter } from 'react-router-dom';
import { Grid, Button } from '@material-ui/core';

import SocialMediaForm from '../forms/ConnectSocialMedia';
import MobileSocialMediaForm from '../forms/MobileConnectSocialMedia';



class ConnectSocialMedia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isInstagramLinked: false,
      isYoutubeLinked: false,
    };
  }

  submitForm() {
    this.props.history.push('/influencer/settings/about-me');
  }

  get_form() {
    if (window.matchMedia('(min-width: 768px)').matches) {
      return <SocialMediaForm />;
    } else {
      return <MobileSocialMediaForm />;
    }
  }

  render() {
    return (
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={3}
        style={{
          marginBottom: 30,
        }}
      >
        {this.get_form()}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 40 }}>
          <Button
            variant="contained"
            onClick={() => {
              this.submitForm();
            }}
            style={{
              background: '#111936',
              color: 'white',
              padding: '8px 28px',
              fontWeight: 700,
              textTransform: 'none',
            }}
          >
            Save and Continue
          </Button>
        </div>
      </Grid>
    );
  }
}

export default withRouter(ConnectSocialMedia);
